import AccessIcon from '@mui/icons-material/LockOpen';
import AccessList from './AccessList';
import AccessEdit from './AccessEdit';
import AccessCreate from './AccessCreate';


const access = {
    list: AccessList,
    edit: AccessEdit,
    create: AccessCreate,
    icon: AccessIcon
};

export default access;